import React from "react";
import "./App.css";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import SignIn from "./pages/SignIn";
import SignUp from "./pages/SignUp";
import LicensePage from "./pages/LicensePage";
import LandingTutorialsPage from "./pages/LandingTutorialsPage.js";
import TutorialsPage from "./pages/TutorialsPage.js";
import LearnerDashboard from "./pages/LearnerDashboard";
import LearnerFeedbackPage from "./pages/LearnerFeedbackPage";
import ModeratorUserManagement from "./pages/ModeratorUserManagementPage.js";
import ModeratorVideoManagement from "./pages/ModeratorVideoManagementPage.js";
import ModeratorFeedback from "./pages/ModeratorFeedbackPage.js";
import ModeratorLicenseManagement from "./pages/ModeratorLicenseManagementPage.js";
import TeacherDownloadPage from "./pages/TeacherDownloadPage";
import TeacherDashboard from "./pages/TeacherDashboard";
import TeacherDemographicReportPage from "./pages/TeacherDemographicReportPage";
import TeacherVideoUploadFormPage from "./pages/TeacherVideoUploadFormPage";
import TeacherFeedbackPage from "./pages/TeacherFeedbackPage.js";
import VideoPlayerPage from "./pages/VideoPlayerPage";
import ProtectedRoute from "./Routing/PrivateRoute.js"; // Import ProtectedRoute
import NotFound from "./components/NotFound.js"; // Import 404 page

// A wrapper to use `useLocation` hook and pass location prop to the NotFound component
function NotFoundWrapper() {
  const location = useLocation(); // Get the current location (i.e., URL path)
  return <NotFound location={location} />;
}

function App() {
  return (
    <Router>
      <div className="pagesall">
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/license" element={<LicensePage />} />
          <Route path="/tutorials" element={<LandingTutorialsPage />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/signup" element={<SignUp />} />
          <Route 
            path="/videoplayer" 
              element={<VideoPlayerPage />} />

          {/* Protected Routes */}
          <Route
            path="/learner"
            element={
              <ProtectedRoute element={LearnerDashboard} allowedRoles={['Student']} />
            }
          />
          <Route
            path="/learner/feedback"
            element={
              <ProtectedRoute element={LearnerFeedbackPage} allowedRoles={['Student']} />
            }
          />
          <Route
            path="/moderator/video-management"
            element={
              <ProtectedRoute element={ModeratorVideoManagement} allowedRoles={['Moderator']} />
            }
          />
          <Route
            path="/moderator/user-management"
            element={
              <ProtectedRoute element={ModeratorUserManagement} allowedRoles={['Moderator']} />
            }
          />
          <Route
            path="/moderator/license-management"
            element={
              <ProtectedRoute element={ModeratorLicenseManagement} allowedRoles={['Moderator']} />
            }
          />
          <Route
            path="/moderator/feedback"
            element={
              <ProtectedRoute element={ModeratorFeedback} allowedRoles={['Moderator']} />
            }
          />
          <Route
            path="/admin/tutorials"
            element={
              <ProtectedRoute element={TutorialsPage} allowedRoles={['Moderator']} />
            }
          />
          <Route
            path="/teacher"
            element={
              <ProtectedRoute element={TeacherDashboard} allowedRoles={['Teacher']} />
            }
          />
          <Route
            path="/teacher/download"
            element={
              <ProtectedRoute element={TeacherDownloadPage} allowedRoles={['Teacher']} />
            }
          />
          <Route
            path="/teacher/demographic-report"
            element={
              <ProtectedRoute element={TeacherDemographicReportPage} allowedRoles={['Teacher']} />
            }
          />
          <Route
            path="/teacher/upload"
            element={
              <ProtectedRoute element={TeacherVideoUploadFormPage} allowedRoles={['Teacher']} />
            }
          />
          <Route
            path="/teacherFeedback"
            element={
              <ProtectedRoute element={TeacherFeedbackPage} allowedRoles={['Teacher']} />
            }
          />
           <Route
            path="/teacher/tutorials"
            element={
              <ProtectedRoute element={TutorialsPage} allowedRoles={['Teacher']} />
            }
          />
          {/* Not Found Route: Show NotFound but retain the URL */}
          <Route path="*" element={<NotFoundWrapper />} /> {/* Catch-all route */}
        </Routes>
      </div>
    </Router>
  );
}

export default App;
